import { useLayoutEffect, useRef } from "react";

/** The visual viewport shrinks with the software keyboard; dvh alone need not. */
export function useMobileViewport<T extends HTMLElement = HTMLElement>(active: boolean) {
  const ref = useRef<T | null>(null);
  useLayoutEffect(() => {
    const element = ref.current;
    if (!active || !element) return;
    const viewport = window.visualViewport;
    let frame = 0;
    const update = () => {
      // Preserve browser pinch zoom; do not resize the app to the zoomed area.
      if (viewport && viewport.scale !== 1) return;
      element.style.setProperty("--mobile-viewport-height", `${viewport?.height ?? window.innerHeight}px`);
      element.style.setProperty("--mobile-viewport-top", `${viewport?.offsetTop ?? 0}px`);
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };
    update();
    viewport?.addEventListener("resize", schedule);
    viewport?.addEventListener("scroll", schedule);
    window.addEventListener("resize", schedule);
    return () => {
      cancelAnimationFrame(frame);
      viewport?.removeEventListener("resize", schedule);
      viewport?.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
      element.style.removeProperty("--mobile-viewport-height");
      element.style.removeProperty("--mobile-viewport-top");
    };
  }, [active]);
  return ref;
}
